import i18next from "i18next";

import { createColumn } from "../../../../components/Table";

/**
 * EN-5078: each row is one dose slot of one day. For patient-add-medication
 * wards the medication carries a structured schedule, so the row shows the
 * dose's own clock time (the time the patient marks it against in the mobile
 * app, e.g. "12:00pm"); Dosage and Route are not part of that design. Other
 * wards (EMed-sourced medications) keep the Dosage and Route columns and have
 * no dose times.
 */
export function buildMedicationAdherenceColumns(patientAddMedication: boolean) {
  return [
    ...(patientAddMedication
      ? []
      : [
          createColumn({
            keyName: "dosage",
            header: () => i18next.t("patientPage_columns_dosage"),
            cell: (info) => info.renderValue(),
            size: 100,
          }),
        ]),
    createColumn({
      keyName: "source",
      header: () => i18next.t("patientPage_columns_source"),
      cell: (info) => info.renderValue(),
      size: 100,
    }),
    ...(patientAddMedication
      ? []
      : [
          createColumn({
            keyName: "route",
            header: () => i18next.t("patientPage_columns_route"),
            cell: (info) => info.renderValue(),
            size: 100,
          }),
        ]),
    createColumn({
      keyName: "frequency",
      header: () => i18next.t("patientPage_columns_schedule"),
      cell: (info) => info.renderValue(),
      size: 120,
    }),
    ...(patientAddMedication
      ? [
          createColumn({
            keyName: "time",
            header: () => i18next.t("patientPage_columns_times"),
            cell: (info) => info.renderValue(),
            size: 100,
          }),
        ]
      : []),
    createColumn({
      keyName: "markedAsTaken",
      header: () => i18next.t("patientPage_columns_marked_as_taken"),
      cell: (info) => info.renderValue(),
      size: 130,
    }),
    createColumn({
      keyName: "actionSent",
      header: () => i18next.t("patientPage_columns_action_sent"),
      cell: (info) => info.renderValue(),
      size: 190,
    }),
    createColumn({
      keyName: "submitted",
      header: () => i18next.t("patientPage_columns_submitted"),
      cell: (info) => info.renderValue(),
      size: 190,
    }),
  ];
}
